/** Configuración de NBF javascript */
nbf.config = function(){
	var raizUrlV = null;

	/**
	 * Obtiene/establece la raiz url
	 * @return string
	 */
	function raizUrl(raizUrl){
		if(raizUrl===undefined)
			return raizUrlV;
		else
			raizUrlV = raizUrl;
	}
	
	return {
		"raizUrl":raizUrl
	};
}();
